import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styles from './NoteList.scss';

import { Notes } from '../../constants/actionTypes';

import { getState as getNotebooksState } from '../../reducers/Notebooks/NotebooksReducer';
import { getState as getNotesState } from '../../reducers/Notes/NotesReducer';

import NoteItem from './NoteItem/NoteItem';

@withRouter
@connect(state => ({
  notebooks: getNotebooksState(state),
  notes: getNotesState(state),
}))
export default class NoteList extends Component {
  static propTypes = {
    notes: PropTypes.object,
  };

  componentWillReceiveProps(nextProps) {
    this.autoLink(nextProps);
  }

  // 自动跳转
  autoLink = (nextProps) => {
    // 先判断path是否已经确定
    if (nextProps.match.path !== '/notebooks/:nbId/notes/:noteId') {
      const { notebooks } = nextProps;
      // 判断是否成功拿到数据
      const { nbId } = nextProps.match.params;
      if (nbId !== null && nbId !== undefined) {
        const seq = notebooks.getIn(['entities', nbId, 'notes'], Immutable.fromJS([]));
        // 判断是否含有文章
        if (seq.size > 0) {
          this.props.history.replace(`/notebooks/${nbId}/notes/${seq.first()}`);
        }
      }
    }
  };

  getNoteItems = () => {
    const { notes, notebooks, match } = this.props;
    const { params: { noteId, nbId } } = match;
    const entities = notes.get('entities');
    if (nbId === undefined || nbId === null) {
      return [];
    }
    const seq = notes.get('status') === Notes.GET_NOTES_FAIL
      ? Immutable.fromJS([])
      : notebooks.getIn(['entities', nbId, 'notes'], this.cacheSeq || Immutable.fromJS([]));
    this.cacheSeq = seq;
    return seq.map((id, index) => {
      return (
        <NoteItem
          key={id}
          index={index}
          preNoteId={seq.get(index - 1)}
          nextNoteId={seq.get(index + 1)}
          note={entities.get(`${id}`)}
          active={+id === +noteId}
          disabled={notes.get('topNoteId') === +id}
        />
      );
    });
  };

  render() {
    return (
      <ul className={styles['note-list']}>
        {this.getNoteItems()}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NoteList/NoteList.js